baseApp.service('UserContextService', [function() {

    var userContextService = {};

    const ROLES = {
        VIEWER: 'VIEWER',
        EDITOR: 'EDITOR',
        SUPER_USER: 'SUPER_USER',
        OWNER: 'OWNER',
    };

    const INTERNAL_ROLES = {
        SUPER_USER: 'SUPER_USER',
        OWNER: 'OWNER',
    }

    var getCookie = function(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    var getUserContext = function() {
        if (authToken) { // we have a token from the auth service
            let permCookie = getCookie('auth-perm');
            let perms = {};
            if (permCookie != "")
                perms = JSON.parse(window.atob(permCookie.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));

            let bearer = JSON.parse(window.atob(authToken.replace('Bearer ', '').split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));

            return Object.assign(bearer, perms);
        } else {
            let permCookie = getCookie('auth-perm');
            let perms = {};
            if (permCookie != "") {
                perms = JSON.parse(window.atob(permCookie.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
            }
            let authTokenCookie = JSON.parse(window.atob(getCookie('auth-token').split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
            return Object.assign(authTokenCookie, perms);
        }
    };

    userContextService.isSystemLogin = function() {
        return getUserContext().accountType === 'SYSTEM';
    }

    userContextService.isDisableGUI = function() {
        return getUserContext().appliedRole === ROLES.VIEWER;
    }

    userContextService.isSystemAdminElevatedForAccount = function(accountId) {
        if(getUserContext().elevatedForAll)
            return true;
        if(accountId === undefined)
            return false;
        return getUserContext().elevatedAccountIds.includes(accountId.toString());
    }

    userContextService.isEditor = function() {
        const uc = getUserContext();
        return uc.role === ROLES.EDITOR || uc.role === ROLES.SUPER_USER || uc.role === ROLES.OWNER;
    }

    userContextService.getRole = function() {
        return getUserContext().role;
    }

    userContextService.getEmail = function() {
        return getUserContext().sub;
    }

    userContextService.getAdminName = function() {
        const uc = getUserContext();
        return {
            first: uc.firstName,
            last: uc.lastName
        }
    };

    userContextService.getAdminId = function() {
        return getUserContext().idnt;
    }

    userContextService.getAdminAccountId = function() {
        const accounts = getUserContext().accountPath.split("_").filter(val => val != "");
        return accounts[accounts.length - 1];
    }

    userContextService.getPreferredUi = function() {
        return getUserContext().pfui;
    }

    userContextService.getRoles = function () {
        return Object.fromEntries(
            Object.entries(ROLES)
                .filter(role => !INTERNAL_ROLES[role[0]])
                .map(([ key, _ ]) => [ key, key ])
        );
    }

    userContextService.getAllRoles = function () {
        return ROLES;
    }

    return userContextService;
}]);
